import { render, staticRenderFns } from "./wait-approve.vue?vue&type=template&id=fd3b4778&scoped=true&"
import script from "./wait-approve.vue?vue&type=script&lang=js&"
export * from "./wait-approve.vue?vue&type=script&lang=js&"
import style0 from "./wait-approve.vue?vue&type=style&index=0&id=fd3b4778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3b4778",
  null
  
)

export default component.exports